import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { getStatusDisplay } from './statusDisplayUtils';

const RentalStatusDisplayer = (props) => {
  const { business, status, className } = props;

  const display = getStatusDisplay(status, business);
  return (<span className={classnames({ [className]: className })}>{display}</span>);
};
const mapStateToProps = (state) => {
  const { business } = state.business;

  return { business };
};
export default connect(mapStateToProps)(RentalStatusDisplayer);
